import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaPhoneAlt, FaYoutube } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { SiGooglemaps } from 'react-icons/si';
import footerLogo from '../assests/img/footer-logo.svg';

const API = 'https://mobileacc.in/ecommerce/wp-json/wc/v3';
const CK = "ck_1d0bfb52b9046a39fb2d906f89f691968931bce6";
const CS = "cs_956c51f2c9249f343bec7f0ecbfd7738654ba424";

const aboutLinks = [
  { label: 'About Us', to: '/about' },
  { label: 'Terms & Conditions', to: '/' },
  { label: 'Contact Us', to: '/contact' },
  { label: 'Privacy Policy', to: '/' },
];

function Footer() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch(`${API}/products/categories?per_page=50&consumer_key=${CK}&consumer_secret=${CS}`)
      .then(res => res.json())
      .then(data => {
        setCategories(Array.isArray(data) ? data.filter(cat => cat.parent === 0) : []);
      })
      .catch(() => setCategories([]));
  }, []);

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer-grid">        

        

       
          <div className="site-footer-column site-footer-contact">        
            <ul>
              <li>
                <SiGooglemaps />
                <span>Address
The Picture Valley
Agra-Jaipur Highway, Near Aaram Baag
Pathaoli Agra (U.P.)
</span>
              </li>
              <li>
                <FaPhoneAlt />
                <a href="tel:+91 800 62727 88">+91 800 62727 88</a>
              </li>
              <li>
                <MdEmail />
                <a href="mailto:thepicturevalley@gmail.com">thepicturevalley@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="site-footer-copyright">
        <div className="container">
          <p>&copy; Copyright 2026 thepicturevalley. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
